import { ExplanationContainer } from '@pages/ExplanationPage/ExplanationContainer';

export default ExplanationContainer;
